export const auth0Config = {
  client_id: process.env.REACT_APP_AUTH0_CLIENT_ID,
  domain: process.env.REACT_APP_AUTH0_DOMAIN,
};

export const PATH = {
  LOGIN: "/",
  DASHBOARD: "/dashboard",
  NewCheckIn: "/checkin",
  CheckInOut: "/checkout",
  LeaveRequest: "/leaverequest",
  AllLeaves: "/allleaves",
  PROFILE: "/profile",
  USERS: "/users/:role",
  FORGOTPASSWORD: "/forgot-password",
  RESETPASSWORD: "/reset-password",
  AllCHECK: "/all-check",
  CREATECHECK: "/create-check",
  MYCHECKS: "/my-checks",
  TEAMCHECKS: "/team-checks",
  EDITCHECK: "/edit-check/:id",
  ALLEMPLOYEES: "/all-employees",

  DELETED_EMPLOYEES: "/deleted-employees",
 VIEWEMPLOYEE: "/view-employee/:id",
  CREATEEMPLOYEE: "/employee/new",
  EDITEMPLOYEE: "/edit-employee/:id",
  ALLREQUESTS: "/all-requests",
  ALLMYREQUESTS: "/all-my-requests",
  CREATEREQUEST: "/create-request",
  EDITREQUEST: "/edit-request/:id",
  VIEWREQUEST: "/view-request/:id",
  ALLANOUNCEMENTS: "/announcements",
  ADDANOUNCEMENTS: "/announcement",
  EDITANOUNCEMENTS: "/announcement/:id",

  ALLHOLIDAYS: "/holidays",
  ADDHOLIDAYS: "/holiday",
  EDITHOLIDAYS: "/holiday/:id",
   MACHINELOGS: "/machine-logs/:userId/:date",
  VIEWOVERTIMEREQUEST: "/view-overtime-request/:id",
     ALLOVERTIMEREQUESTS: "/all-overtime-requests", 
      CREATEOVERTIMEREQUEST: "/create-overtime-request",
  EDITOVERTIMEREQUEST: "/edit-overtime-request/:id",
};

// const baseUrl = "http://localhost:5000/api";
// const LIVE_URL = "http://localhost:5000/";
const baseUrl = process.env.REACT_APP_BASE_URL || "http://localhost:5000/api";
const LIVE_URL = process.env.REACT_APP_LIVE_URL || "http://localhost:5000/";

const PAGE_LIMIT = 12;

const APP_SETTINGS = {
  API_PATH: {
    USER: {
      login: baseUrl + "/users/login",
      logout: baseUrl + "/users/logout",
      changePassword: baseUrl + "/users/changePassword",
      // /user/changePassword
      // remove: baseUrl + "/users/delete",
      create: baseUrl + "/users/create",
      getAllUsers: baseUrl + "/users/user", // Method: GET
      createEmployee: baseUrl + "/users/user", // Method: POST
      updateUser: baseUrl + "/users/user", // Method: PUT
      getUser: baseUrl + "/users/user", // For single user, e.g., /users/user/123
      remove: baseUrl + "/users/user",
      forgetPassword: baseUrl + "/users/user/forgot-password",
      resetPassword: baseUrl + "/users/user/reset-password",
      restore: baseUrl + "/users/user/:id/restore",
      getNotCheckedIn: baseUrl + "/users/not-checked-in",
      getOnBreak: baseUrl + "/users/on-break",
    },
    AVATAR: {
      addImage: baseUrl + "/images/avatar",
    },
    attendance: {
      getMyTodayAttendance: baseUrl + "/attendance/my-today",
      markMyAttendance: baseUrl + "/attendance/my-attendance",
      checkInUser: baseUrl + "/attendance/checkout",
      startBreak: baseUrl + "/break/start",
      endBreak: baseUrl + "/break/end",
      checkOutUser: baseUrl + "/attendance/check-out",
      create: baseUrl + "/attendance/check-in",
      getAll: baseUrl + "/attendance",
      update: baseUrl + "/attendance/update",
      delete: baseUrl + "/attendance",
      getOne: baseUrl + "/attendance",
    },
OVERTIME: {
      create: baseUrl + "/overtime",
      getById: baseUrl + "/overtime",
      getAll: baseUrl + "/overtime",
      updateStatus: baseUrl + "/overtime",
      update: baseUrl + "/overtime", 
      delete: baseUrl + "/overtime", 
    },
    LEAVE: {
      getAll: baseUrl + "/leaves",
      getById: baseUrl + "/leaves",
      create: baseUrl + "/leaves",
      update: baseUrl + "/leaves",
      delete: baseUrl + "/leaves",
      approveOrReject: baseUrl + "/leaves",
    },

    DASHBOARD: {
      get: baseUrl + "/dashboard",
    },
    ANNOUNCEMENTS: {
      get: baseUrl + "/announcement",
      getBYId: baseUrl + "/announcement",
      add: baseUrl + "/announcement",
      update: baseUrl + "/announcement",
      delete: baseUrl + "/announcement",
      userAnnouncements: baseUrl + "/user-announcements",
      dismissUserAnnouncements: baseUrl + "/announcement-dismiss",
    },
    HOLIDAYS: {
      get: baseUrl + "/holiday",
      getBYId: baseUrl + "/holiday",
      add: baseUrl + "/holiday",
      update: baseUrl + "/holiday",
      delete: baseUrl + "/holiday",
    },
  },
};

const ROLE = [
  {
    id: "admin",
    value: "Admin",
  },
  {
    id: "",
    value: "All",
  },
  {
    id: "employee",
    value: "Employee",
  },
];
const TEAMLEADFILTER = [
  {
    id: "",
    name: "All",
  },
  {
    id: true,
    name: "Team Lead",
  },
  {
    id: false,
    name: "Non Team Lead",
  },
];
const USER_ROLE_LIST = {
  ADMIN: "admin",
  SUPERADMIN: "superAdmin",
  CUSTOMER: "customer",
};

export {
  TEAMLEADFILTER,
  USER_ROLE_LIST,
  ROLE,
  APP_SETTINGS,
  PAGE_LIMIT,
  LIVE_URL,
};
